if(typeof pino-pretty === 'undefined') { var e = new Error("Cannot find module 'pino-pretty'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = pino-pretty;